import { render, staticRenderFns } from "./addReportCustomComponent.vue?vue&type=template&id=74ad8e58"
import script from "./addReportCustomComponent.vue?vue&type=script&lang=js"
export * from "./addReportCustomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports